import axios from '../utils/axios';

export default function getUnverifiedRecruitersCount(adminId, params) {
    return axios.get(`/admin/${adminId}/get-unverified-recruiters-count`, { params });
}